'use client';

const getIconColor = ({
  emphasis,
  disabled,
  variant,
  onDark
}) => {
  if (disabled) {
    return onDark ? "onDark.disabled.muted" : "onLight.disabled.muted";
  }
  if (emphasis === "high") {
    const iconColorsHigh = {
      default: "onLight.icon.primary",
      // a design gap
      primary: onDark ? "onAction.primary.base" : "onAction.primary.dark",
      danger: onDark ? "action.neutral.darkest" : "action.destructive.lightest",
      upsell: onDark ? "action.neutral.darkest" : "action.upsell.lightest"
    };
    return iconColorsHigh[variant];
  }
  const iconColors = {
    default: onDark ? "onDark.icon.primary" : "onLight.icon.primary",
    primary: "action.primary.lightest",
    // a design gap
    danger: onDark ? "action.destructive.light" : "action.destructive.dark",
    upsell: onDark ? "action.upsell.light" : "action.upsell.dark"
  };
  return iconColors[variant];
};
export {
  getIconColor
};
